/*
 * @Author: mikey.zhaopeng
 * @Date: 2021-07-05 17:04:22
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2021-07-05 17:15:41
 */
import { IYxInputPropTypes } from "./basePropType";
import PropTypes from "prop-types";
import React from "react";
import { Input } from "antd";

export const IpasswordPropTypes = {
  ...IYxInputPropTypes,

  //密码强度类型：lv1、lv2、lv3
  strength: PropTypes.oneOf(["lv1", "lv2", "lv3"]),

  //是否需要对比的密码输入框id，用于对比两次密码是否一致
  isContrastId: PropTypes.string,

  //是否显示切换按钮
  isVisibilityToggle: PropTypes.bool,

  //输入回调，返回密码的强度：weak-弱middle-中strong-强
  callback: PropTypes.func,

  // 密码长度区间
  lenInterval: PropTypes.arrayOf(PropTypes.number),
};

export const passwordDefaultProps = () => ({
  isVisibilityToggle: true,
  strength: "lv1", // null/lv1/lv2/lv3/every 密码强度低/中/高,为null则没有校验，默认为最弱校验
  isContrastId: null,
  rules: {},
  inputParam: {},
  children: <Input.Password />, //子节点
  lenInterval: [],
  styleParam: {
    width: "sm", //宽度  xxs,xs,sm,md,lg,xl
    size: "default", //大小
    type: "default", //类型
  },
});



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/IpropType/passwordPropType.js